function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Button } from '@progress/kendo-react-buttons';
class ErrorPage extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onRetry", () => {
      if (this.props.onRetry) this.props.onRetry();else window.location.reload();
    });
    _defineProperty(this, "onHome", () => {
      if (this.props.history) this.props.history.push('/');else window.location.href = '/';
    });
    _defineProperty(this, "onToggleDetails", () => {
      this.setState({
        showDetails: !this.state.showDetails
      });
    });
    this.state = {
      showDetails: false
    };
  }
  render() {
    const code = this.props.code || '';
    const title = this.props.title || "Something went wrong";
    const description = this.props.description || "We couldn't complete your request. This is usually temporary — try refreshing or head back to the dashboard.";
    const message = this.props.message;
    return /*#__PURE__*/React.createElement("div", {
      className: "plk-error-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-error-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-error-illustration"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons plk-error-icon"
    }, "error_outline"), code && /*#__PURE__*/React.createElement("div", {
      className: "plk-error-code"
    }, code)), /*#__PURE__*/React.createElement("h2", {
      className: "plk-error-title"
    }, title), /*#__PURE__*/React.createElement("p", {
      className: "plk-error-description"
    }, description), /*#__PURE__*/React.createElement("div", {
      className: "plk-error-actions"
    }, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: this.onRetry
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, "refresh"), " Try again"), /*#__PURE__*/React.createElement(Button, {
      onClick: this.onHome
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, "home"), " Back to dashboard")), message && /*#__PURE__*/React.createElement("div", {
      className: "plk-error-details"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "plk-error-details-toggle",
      onClick: this.onToggleDetails
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '16px',
        verticalAlign: 'middle'
      }
    }, this.state.showDetails ? 'expand_less' : 'expand_more'), this.state.showDetails ? 'Hide technical details' : 'Show technical details'), this.state.showDetails && /*#__PURE__*/React.createElement("pre", {
      className: "plk-error-details-message"
    }, message))));
  }
}
export default withRouter(ErrorPage);